import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import AcademicYearsTable from '../../components/academicYears/AcademicYearsTable';

const AcademicYearsArchive = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <AcademicYearsTable isArchive />
        </WrapperSection>
    );
};

export default AcademicYearsArchive;
